import axios from "axios";
import { AuthContext } from "components/lib";
import { useContext, useEffect, useState, useRef } from "react";

const FrillWidget = () => {
  const [userData, setUserData] = useState(null);
  const authContext = useContext(AuthContext);
  const identifiedRef = useRef(false);

  const getUser = async () => {
    try {
      const res = await axios.get("/api/user");
      const d = res?.data?.data;
      if (d?.email && d?.name) {
        setUserData({
          name: d.name,
          email: d.email,
        });
      }
    } catch (err) {
      console.error("Error fetching user for Frill identify", err);
    }
  };

  useEffect(() => {
    const isLoggedIn = !!authContext?.user;
    const isClient = authContext?.user?.permission === "client";

    if (!isLoggedIn || isClient) return;

    if (!userData) getUser();
  }, [authContext]);

  useEffect(() => {
    if (!userData || identifiedRef.current) return;

    const identifyUser = () => {
      if (window.Frill) {
        window.Frill("identify", {
          email: userData.email,
          name: userData.name,
        });
        identifiedRef.current = true;
        return true;
      }
      return false;
    };

    if (!identifyUser()) {
      const interval = setInterval(() => {
        if (identifyUser()) {
          clearInterval(interval);
        }
      }, 500);

      return () => clearInterval(interval);
    }
  }, [userData]);

  return null;
};

export default FrillWidget;
